// Enhance the existing forms without replacing their inputs or booking handlers.
(() => {
    document.querySelectorAll('.home-page--landing [data-transfer-search-form]').forEach(form => {
        const card = form.querySelector('.transfer-detail-hero__card');
        const counters = card.querySelector('.home-search-hero__field-row');
        const returnStage = card.querySelector('.home-search-hero__return-stage');
        const addLeg = card.querySelector('[data-transfer-search-waypoint-add]');
        if (!counters || !returnStage || !addLeg) return;

        const makeDisclosure = (className, text) => {
            const details = document.createElement('details');
            details.className = className;
            const summary = document.createElement('summary');
            summary.textContent = text;
            details.append(summary);
            return details;
        };
        const travelers = makeDisclosure('home-travelers', '');
        const summary = travelers.querySelector('summary');
        summary.innerHTML = '<span><span class="home-travelers__label"></span><span class="home-travelers__value" aria-live="polite" aria-atomic="true"><span class="home-travelers__count" aria-hidden="true"><i class="fa-regular fa-user"></i><span data-home-passenger-count></span></span><span aria-hidden="true">·</span><span class="home-travelers__count" aria-hidden="true"><i class="fa-solid fa-suitcase"></i><span data-home-luggage-count></span></span><span class="visually-hidden" data-home-travelers-description></span></span></span><i class="fa-solid fa-chevron-down" aria-hidden="true"></i>';
        const label = summary.querySelector('.home-travelers__label');
        label.textContent = form.dataset.homeTravelersLabel;
        label.title = form.dataset.homeTravelersLabel;
        const passengerCount = summary.querySelector('[data-home-passenger-count]');
        const luggageCount = summary.querySelector('[data-home-luggage-count]');
        const description = summary.querySelector('[data-home-travelers-description]');
        counters.before(travelers);
        travelers.append(counters);

        card.querySelector('[data-transfer-search-service-toggle]').after(addLeg);
        addLeg.querySelectorAll('span').forEach(label => {
            label.textContent = form.dataset.homeAddLegLabel;
        });
        travelers.before(returnStage);
        const swap = card.querySelector('[data-transfer-search-swap]');
        const swapAnchor = document.createComment('swap control');
        swap.before(swapAnchor);
        const desktop = window.matchMedia('(min-width: 1200px)');
        const layout = () => {
            if (desktop.matches) swapAnchor.before(swap);
            else card.querySelector('.home-search-hero__field--drop').prepend(swap);
        };
        desktop.addEventListener('change', layout);
        layout();
        form.dataset.homeMinimalReady = 'true';

        function sync() {
            const passengers = Number(form.querySelector('[name="passengers"]').value) || 1;
            const luggage = Number(form.querySelector('[name="luggage"]').value) || 0;
            const passengerText = passengers === 1 ? form.dataset.homePassengerOne : form.dataset.homePassengerMany.replace(':count', passengers);
            const luggageText = luggage === 1 ? form.dataset.homeLuggageOne : form.dataset.homeLuggageCount.replace(':count', luggage);
            const text = passengerText + ' · ' + luggageText;
            if (passengerCount.textContent !== String(passengers)) passengerCount.textContent = String(passengers);
            if (luggageCount.textContent !== String(luggage)) luggageCount.textContent = String(luggage);
            if (description.textContent !== text) description.textContent = text;
            form.querySelectorAll('.transfer-detail-hero__field--location').forEach(field => {
                const input = field.querySelector('.transfer-detail-hero__input');
                if (!input) return;
                let locationValue = input.closest('.home-search-hero__location-value');
                if (!locationValue) {
                    locationValue = document.createElement('div');
                    locationValue.className = 'home-search-hero__location-value';
                    const address = document.createElement('span');
                    address.className = 'home-search-hero__location-text';
                    address.setAttribute('aria-hidden', 'true');
                    input.before(locationValue);
                    locationValue.append(input, address);
                }
                // Keep the original autocomplete input; show its complete value when idle.
                const address = locationValue.querySelector('.home-search-hero__location-text');
                if (address.textContent !== input.value) address.textContent = input.value;
                field.classList.toggle('home-field-empty', !input?.value.trim());
                const clear = field.querySelector('[data-transfer-search-clear]');
                if (clear) clear.hidden = !input?.value.trim();
            });
        }
        ['input', 'change', 'transfer:place-selected', 'focusin', 'focusout'].forEach(type => form.addEventListener(type, sync));
        // Swaps and route selection also update values programmatically in click handlers.
        form.addEventListener('click', () => queueMicrotask(sync));
        new MutationObserver(sync).observe(counters, { childList: true, subtree: true, characterData: true });
        new MutationObserver(sync).observe(card.querySelector('[data-transfer-search-waypoints]'), { childList: true });
        // Draft restoration updates the existing output nodes, so the same observer updates the summary.
        sync();

        card.addEventListener('click', event => {
            if (event.target.closest('button, a, summary, .autocomplete-custom, .home-search-popular-places')) return;
            const field = event.target.closest('.transfer-detail-hero__field');
            const input = field?.querySelector('input.transfer-detail-hero__input');
            if (input && event.target !== input && !input.disabled) input.focus();
        });
        document.addEventListener('pointerdown', event => {
            if (!travelers.contains(event.target)) travelers.open = false;
        });
        form.addEventListener('keydown', event => {
            if (event.key !== 'Escape') return;
            const disclosure = event.target.closest('.home-travelers');
            if (disclosure?.open) { disclosure.open = false; disclosure.querySelector('summary').focus(); }
        });
    });
})();
